import { render, staticRenderFns } from "./PersonDeleteProvider.vue?vue&type=template&id=91e24678&scoped=true&"
import script from "./PersonDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./PersonDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e24678",
  null
  
)

export default component.exports